(function () {
  if (customElements.get('global-announcement-bar')) return;

  class GlobalAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.onResize = this.updateMarquee.bind(this);
      this.updateMarquee();
      window.addEventListener('resize', this.onResize);

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.onResize);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    updateMarquee() {
      const marqueeEnabled = this.dataset.marquee === 'true';
      const wrapper = this.querySelector('[data-announcement-track]');
      const tracks = this.querySelectorAll('[data-announcement-content]');
      const primaryTrack = tracks[0];

      if (!wrapper || !primaryTrack) return;

      if (!marqueeEnabled) {
        wrapper.style.animation = 'none';
        wrapper.style.transform = 'none';
        tracks.forEach((track, index) => {
          track.hidden = index > 0;
        });
        wrapper.style.width = '100%';
        wrapper.style.justifyContent = 'center';
        return;
      }

      tracks.forEach((track) => {
        track.hidden = false;
      });
      wrapper.style.width = 'max-content';
      wrapper.style.justifyContent = 'flex-start';

      const baseSpeed = parseFloat(this.dataset.speed) || 30;
      const contentWidth = primaryTrack.offsetWidth;
      // Keep the same pixel scroll speed on all viewports.
      // baseSpeed is treated as seconds to scroll a 1200px-wide reference.
      const referenceWidth = 1200;
      const duration = baseSpeed * (contentWidth / referenceWidth);

      wrapper.style.animation = '';
      wrapper.style.animationDuration = Math.max(duration, 1) + 's';
    }
  }

  customElements.define('global-announcement-bar', GlobalAnnouncementBar);
})();
